import {
  GenericForm,
  GenericFormLogicalField,
  genericBeforeValidate_removeDefaultKeyedError,
  genericValidate_textField,
  ValidationEvent,
  GenericTextFieldValidationOptions,
} from "../../../hooks";

const maxNameLength = 50;

interface NameFormLogicProps<Form extends GenericForm, App extends unknown> {
  required?: boolean;
  guard?: GenericTextFieldValidationOptions<Form, App>["guard"];
}

export const nameFormLogic = <Form extends GenericForm, App extends unknown>(
  props: NameFormLogicProps<Form, App> = {}
): GenericFormLogicalField<Form, App> => ({
  presentation: props,
  validationEvents: [
    ValidationEvent.onChange,
    ValidationEvent.onBlur,
    ValidationEvent.onSubmit,
  ],
  beforeValidate: genericBeforeValidate_removeDefaultKeyedError,
  validate: genericValidate_textField({
    required: props.required,
    maxLength: maxNameLength,
    guard: props.guard,
  }),
});
